module.exports = __webpack_public_path__ + "media/img/pages/companies/pmint-3b24903b7cd119946d430489d4b4cb5e.png";